module.exports = __webpack_public_path__ + "static/img/usage.32373e89.svg";